import * as z$1 from "zod/v4";
//#region src/schemas/protocol/conversation-compaction.ts
const conversationCompactionMarkerSchema = z$1.strictObject({
	completedAtMs: z$1.number().int().nonnegative().max(Number.MAX_SAFE_INTEGER),
	count: z$1.number().int().positive().max(100),
	v: z$1.literal(1)
});
//#endregion
export { conversationCompactionMarkerSchema };

//# sourceMappingURL=conversation-compaction.js.map